var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { componentFactory } from '@rmwc/base';
import { withProviderContext } from '@rmwc/provider';
var TypographyRoot = componentFactory({
    displayName: 'TypographyRoot',
    tag: 'span',
    classNames: function (props) {
        var _a;
        return [
            (_a = {},
                _a["mdc-typography--" + props.use] = props.use,
                _a)
        ];
    },
    consumeProps: ['use']
});
/** The Typography Component */
export var Typography = withProviderContext()(React.forwardRef(function Typography(_a, ref) {
    var _b = _a.providerContext, providerContext = _b === void 0 ? {} : _b, rest = __rest(_a, ["providerContext"]);
    var typographyOptions = providerContext.typography;
    var tag = (typographyOptions
        ? typographyOptions[rest.use] || typographyOptions.defaultTag
        : undefined) || rest.tag;
    return React.createElement(TypographyRoot, __assign({}, rest, { tag: tag, ref: ref }));
}));
Typography.displayName = 'Typography';
